/*
 * Exposure Club pop-up + split test (sections/ea-popup.liquid).
 * Picks a version for each new visitor (weights from the order board), shows it on its trigger and
 * beacons view/close events. The button opens Shopify's sign-in sheet; when the visitor comes back
 * signed in, that's the "signup" (an account) and they get their first-order code.
 * Signed-in Club members with an order get the member code applied once per session.
 */
(function () {
  'use strict';

  var root = document.getElementById('EaPopup');
  var configEl = document.querySelector('[data-ea-popup-config]');
  if (!root || !configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var STORE_KEY = 'eaPopup';
  var SESSION_KEY = 'eaPopupSession';
  var DAY = 86400000;
  var EXCLUDED = ['cart', 'password', 'gift_card', 'captcha', 'challenge'];

  var versions = (cfg.versions || []).filter(function (v) {
    return /^[A-D]$/.test(v.id);
  });
  // Two blocks with the same letter: keep the first.
  versions = versions.filter(function (v, i) {
    return versions.findIndex(function (w) { return w.id === v.id; }) === i;
  });
  var board = String(cfg.board || '').replace(/\/$/, '');

  // ---------- Storage (never trusted to exist) ----------

  function read(key, storage) {
    try {
      return JSON.parse((storage || window.localStorage).getItem(key)) || {};
    } catch (e) {
      return {};
    }
  }
  function write(key, value, storage) {
    try {
      (storage || window.localStorage).setItem(key, JSON.stringify(value));
    } catch (e) {
      /* private mode etc. */
    }
  }
  var state = read(STORE_KEY);
  function save() {
    write(STORE_KEY, state);
  }
  if (!state.vid) {
    state.vid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    save();
  }

  var params = new URLSearchParams(window.location.search);
  var previewParam = (params.get('ea_popup') || '').toUpperCase();
  if (previewParam === 'RESET') {
    try {
      window.localStorage.removeItem(STORE_KEY);
      window.sessionStorage.removeItem(SESSION_KEY);
    } catch (e) { /* ignore */ }
    state = { vid: state.vid };
    save();
  }
  var previewVersion = versions.find(function (v) { return v.id === previewParam; }) || null;
  // Preview and the theme editor never count towards the test.
  var tracking = !previewVersion && !cfg.designMode && Boolean(board);

  // ---------- Events to the order board ----------

  function beacon(type, version) {
    if (!tracking || !version) return;
    var body = JSON.stringify({ v: version.id, e: type, vid: state.vid, l: version.heading, c: version.code, m: cfg.memberCode || '' });
    var url = board + '/popup/event';
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, body)) return;
    } catch (e) { /* fall through */ }
    try {
      fetch(url, { method: 'POST', body: body, mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain' } });
    } catch (e) { /* ignore */ }
  }

  // ---------- Toast (member messages) ----------

  var toast = document.querySelector('[data-ea-popup-toast]');
  function showToast(text) {
    if (!toast || !text) return;
    toast.querySelector('[data-ea-popup-toast-text]').textContent = text;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-open'); });
    var timer = setTimeout(hideToast, 9000);
    toast.querySelector('[data-ea-popup-toast-close]').onclick = function () {
      clearTimeout(timer);
      hideToast();
    };
  }
  function hideToast() {
    toast.classList.remove('is-open');
    setTimeout(function () { toast.hidden = true; }, 300);
  }

  // ---------- Signed-in customers: account credit + member code ----------

  function handleSignedIn() {
    var c = cfg.customer || {};
    if (!c.signedIn) return false;
    // They pressed the pop-up's join button and are now signed in (new account or existing one):
    // that's the conversion. New customers get their first-order code straight away.
    var pending = state.pending;
    if (pending && !state.signedUp && Date.now() - pending.at < 2 * DAY) {
      var joined = versions.find(function (x) { return x.id === pending.v; });
      if (joined) {
        state.signedUp = { v: joined.id, code: joined.code, at: Date.now() };
        delete state.pending;
        save();
        beacon('signup', joined);
        if (c.orders < 1 && joined.code) {
          state.memberWelcomed = true;
          save();
          showSuccess(joined);
          open(joined, { silent: true, keepStep: true });
          return true;
        }
      }
    }
    if (!c.club || !cfg.memberCode) return true;
    var session = read(SESSION_KEY, window.sessionStorage);
    if (c.orders >= 1) {
      if (!session.memberApplied) {
        fetch('/discount/' + encodeURIComponent(cfg.memberCode), { credentials: 'same-origin' }).then(function () {
          session.memberApplied = true;
          write(SESSION_KEY, session, window.sessionStorage);
          showToast(cfg.memberAppliedText);
        }).catch(function () { /* code still works if typed at checkout */ });
      }
    } else if (!state.memberWelcomed) {
      state.memberWelcomed = true;
      save();
      showToast(cfg.memberFirstText);
    }
    return true;
  }

  // ---------- Which version ----------

  function pickWeighted(split) {
    var ids = versions.map(function (v) { return v.id; });
    var weights = ids.map(function (id) { return Math.max(0, Number(split && split[id]) || 0); });
    var total = weights.reduce(function (a, b) { return a + b; }, 0);
    if (!total) weights = ids.map(function () { return 1; });
    total = weights.reduce(function (a, b) { return a + b; }, 0);
    var r = Math.random() * total;
    for (var i = 0; i < ids.length; i += 1) {
      r -= weights[i];
      if (r < 0) return ids[i];
    }
    return ids[ids.length - 1];
  }

  function chooseVersion() {
    if (previewVersion) return Promise.resolve(previewVersion);
    var saved = versions.find(function (v) { return v.id === state.v; });
    if (saved) return Promise.resolve(saved);
    var ids = versions.map(function (v) { return v.id; }).sort().join(',');
    var done = function (split) {
      var id = pickWeighted(split);
      state.v = id;
      state.assignedAt = Date.now();
      save();
      return versions.find(function (v) { return v.id === id; });
    };
    if (!board || versions.length < 2) return Promise.resolve(done(null));
    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 2500);
    return fetch(board + '/popup/config?variants=' + ids, { mode: 'cors', signal: controller && controller.signal })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; })
      .then(function (body) {
        clearTimeout(timer);
        return done(body && body.split);
      });
  }

  // ---------- Eligibility ----------

  function eligible() {
    if (previewVersion || cfg.designMode) return true;
    if (!cfg.enabled || !versions.length) return false;
    var t = String(cfg.template || '');
    if (EXCLUDED.indexOf(t) !== -1 || t.indexOf('customers') === 0) return false;
    if (t === 'page' && /contact/.test(cfg.templateSuffix || '')) return false;
    if (t === 'product' && !cfg.showOnProducts) return false;
    if (state.signedUp) return false;
    if (state.closedAt && Date.now() - state.closedAt < (cfg.snoozeDays || 14) * DAY) return false;
    return true;
  }

  // Something else is open (cart drawer, Club drawer, menu, product builder modal).
  function busy() {
    // Drawers and modals lock scrolling with overflow-hidden(-*) on <body>.
    if (/\boverflow-hidden/.test(document.body.className)) return true;
    return Boolean(document.querySelector('cart-drawer.active, #EpkClubDrawer.active, details[open] > .menu-drawer'));
  }

  // ---------- Dialog ----------

  var card = root.querySelector('.ea-popup__card');
  var current = null;
  var lastFocus = null;

  function fill(version) {
    current = version;
    root.dataset.version = version.id;
    ['eyebrow', 'heading', 'text', 'button'].forEach(function (slot) {
      var el = root.querySelector('[data-ea-popup-slot="' + slot + '"]');
      if (el) el.textContent = version[slot] || '';
    });
  }

  function step(name) {
    root.querySelectorAll('[data-ea-popup-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-ea-popup-step') !== name;
    });
  }

  function open(version, opts) {
    fill(version);
    if (!(opts && opts.keepStep)) step('offer');
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('ea-popup-open');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      setTimeout(function () {
        var target = root.querySelector('[data-ea-popup-step]:not([hidden]) .ea-popup__input') || card;
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      }, 220);
    });
    if (!(opts && opts.silent)) {
      var seen = state.viewed || {};
      if (!seen[version.id]) {
        beacon('view', version);
        seen[version.id] = Date.now();
        state.viewed = seen;
        save();
      }
    }
  }

  function close(reason) {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('ea-popup-open');
    setTimeout(function () { root.hidden = true; }, 260);
    if (reason === 'dismiss' && !state.signedUp && !previewVersion && !cfg.designMode) {
      state.closedAt = Date.now();
      save();
      beacon('close', current);
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-ea-popup-close]')) close('dismiss');
  });
  document.addEventListener('keydown', function (event) {
    if (root.hidden) return;
    if (event.key === 'Escape') close('dismiss');
    if (event.key === 'Tab') {
      var focusables = Array.prototype.filter.call(
        card.querySelectorAll('a[href], button, input:not([type="hidden"])'),
        function (el) { return !el.closest('[hidden]') && el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  // ---------- Join = create an account ----------

  function showSuccess(version) {
    root.querySelector('[data-ea-popup-code]').textContent = version.code || '';
    var apply = root.querySelector('[data-ea-popup-apply]');
    var back = window.location.pathname + window.location.search.replace(/([?&])ea_popup=[^&]*/g, '$1').replace(/[?&]+$/, '');
    apply.href = '/discount/' + encodeURIComponent(version.code || '') + '?redirect=' + encodeURIComponent(back || '/');
    apply.hidden = !version.code;
    step('success');
  }

  // The join button opens Shopify's sign-in sheet (assets/ea-signin.js). Remember which version sent
  // them; handleSignedIn() credits it and shows the code once they're back signed in.
  root.addEventListener('click', function (event) {
    if (!event.target.closest('[data-ea-popup-join]') || !current) return;
    if (previewVersion || cfg.designMode) {
      // Preview: show the code step without opening the sign-in.
      event.preventDefault();
      event.stopPropagation();
      showSuccess(current);
      return;
    }
    state.pending = { v: current.id, at: Date.now() };
    save();
  });

  root.querySelector('[data-ea-popup-copy]').addEventListener('click', function (event) {
    var code = root.querySelector('[data-ea-popup-code]').textContent;
    var button = event.currentTarget;
    var done = function () {
      button.textContent = 'Copied';
      setTimeout(function () { button.textContent = 'Copy'; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else done();
  });

  // ---------- Triggers ----------

  function arm(version) {
    var fired = false;
    var cleanups = [];
    function fire() {
      if (fired) return;
      if (busy()) {
        setTimeout(fire, 4000);
        return;
      }
      fired = true;
      cleanups.forEach(function (fn) { fn(); });
      open(version);
    }
    var desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var trigger = version.trigger || 'delay';
    if (trigger === 'exit' && desktop) {
      var onOut = function (event) {
        if (!event.relatedTarget && event.clientY <= 8) fire();
      };
      document.addEventListener('mouseout', onOut);
      cleanups.push(function () { document.removeEventListener('mouseout', onOut); });
      // Some people never move to leave: fall back after a long while.
      var late = setTimeout(fire, 60000);
      cleanups.push(function () { clearTimeout(late); });
      return;
    }
    if (trigger === 'scroll') {
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0 || window.scrollY / max >= 0.5) fire();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      cleanups.push(function () { window.removeEventListener('scroll', onScroll); });
      var fallback = setTimeout(fire, 45000);
      cleanups.push(function () { clearTimeout(fallback); });
      return;
    }
    // Delay counts only while the tab is visible.
    var remaining = Math.max(3, Number(version.delay) || 12) * 1000;
    var started = Date.now();
    var timer = setTimeout(fire, remaining);
    var onVisibility = function () {
      if (document.hidden) {
        clearTimeout(timer);
        remaining -= Date.now() - started;
      } else {
        started = Date.now();
        timer = setTimeout(fire, Math.max(0, remaining));
      }
    };
    document.addEventListener('visibilitychange', onVisibility);
    cleanups.push(function () {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    });
  }

  // The account step opens Shopify's sign-in sheet (assets/ea-signin.js); get out of its way.
  document.addEventListener('ea:signin-open', function () {
    close('signin');
  });

  // ---------- Theme editor ----------

  if (cfg.designMode) {
    var showBlock = function (blockId) {
      var v = versions.find(function (x) { return x.blockId === blockId; }) || versions[0];
      if (v) open(v, { silent: true });
    };
    document.addEventListener('shopify:block:select', function (event) {
      if (root.contains(event.target)) showBlock(event.detail.blockId);
    });
    document.addEventListener('shopify:section:select', function (event) {
      if (event.target.contains(root) || root.contains(event.target)) showBlock(null);
    });
    document.addEventListener('shopify:section:deselect', function () { close('editor'); });
    return;
  }

  // ---------- Welcome email ----------

  // Tells the order board once per browser that this customer is signed in. The board emails a
  // welcome (and Stefan's note later) to customers it hasn't welcomed before, whichever way they
  // signed in (pop-up, Club drawer, checkout).
  function sayHello() {
    var c = cfg.customer || {};
    if (!c.signedIn || !c.id || !board || cfg.designMode) return;
    var key = 'eaWelcomeHello';
    var sent = null;
    try { sent = window.localStorage.getItem(key); } catch (e) { /* no storage: send anyway */ }
    if (sent === String(c.id)) return;
    var body = JSON.stringify({ id: String(c.id) });
    var url = board + '/welcome/hello';
    var ok = false;
    try { ok = navigator.sendBeacon && navigator.sendBeacon(url, body); } catch (e) { /* fall through */ }
    if (!ok) {
      try { fetch(url, { method: 'POST', body: body, mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain' } }); } catch (e) { /* ignore */ }
    }
    try { window.localStorage.setItem(key, String(c.id)); } catch (e) { /* ignore */ }
  }

  // ---------- Start ----------

  sayHello();
  if (handleSignedIn() && !previewVersion) return;
  if (!eligible()) return;

  chooseVersion().then(function (version) {
    if (!version) return;
    if (previewVersion) {
      open(version, { silent: true });
      return;
    }
    arm(version);
  });
})();
